export const Modal = () => ({
  showModal: false,

  openModal() {
    this.showModal = true;
    document.body.style.overflow = 'hidden';
  },
  closeModal() {
    this.showModal = false;
    document.body.style.overflow = 'auto';
  }
});
